import React from 'react';
import { Outlet, NavLink, useLocation } from 'react-router-dom';
import { Bot, Database, BarChart3 } from 'lucide-react';
import { useUserContext, hasPageAccess } from '../../context/userContext';
import { ToastProvider } from '../email/shared/ToastProvider';
import './AIChatbot.css';

/**
 * AIChatbotModule
 * Layout wrapper for the AI chatbot section. Provides header + tab nav and
 * an Outlet for the active sub-route (config / knowledge-base / logs).
 */
const AIChatbotModule = () => {
  const location = useLocation();
  const { userCtx } = useUserContext();
  const canAccessPage = (pageKey) => !userCtx?.pages || hasPageAccess(userCtx, pageKey);
  const isActive = (path) =>
    location.pathname === path || location.pathname.startsWith(path + '/');

  return (
    <ToastProvider>
      <div className="ai-module">
        <div className="ai-module-header">
          <h1>
            <Bot size={26} color="#4f46e5" />
            AI Chatbot
          </h1>
          <p>Configure your AI assistant, manage its knowledge base, and review conversations.</p>

          <nav className="ai-tabs">
            {canAccessPage('ai_chatbot') && (
              <NavLink
                to="/dashboard/ai-chatbot"
                end
                className={() => 'ai-tab' + (location.pathname === '/dashboard/ai-chatbot' ? ' active' : '')}
              >
                <Bot size={16} />
                Configuration
              </NavLink>
            )}
            {canAccessPage('knowledge_base') && (
              <NavLink
                to="/dashboard/ai-chatbot/knowledge-base"
                className={() => 'ai-tab' + (isActive('/dashboard/ai-chatbot/knowledge-base') ? ' active' : '')}
              >
                <Database size={16} />
                Knowledge Base
              </NavLink>
            )}
            {canAccessPage('ai_chatbot') && (
              <NavLink
                to="/dashboard/ai-chatbot/logs"
                className={() => 'ai-tab' + (isActive('/dashboard/ai-chatbot/logs') ? ' active' : '')}
              >
                <BarChart3 size={16} />
                Conversations
              </NavLink>
            )}
          </nav>
        </div>

        <div className="ai-module-content">
          <Outlet />
        </div>
      </div>
    </ToastProvider>
  );
};

export default AIChatbotModule;
